// import _ from 'lodash'
/* eslint-disable */
import { getConfig } from '@/api/common.js'
import { ajaxSend } from '@/api/report.js'
import _ from 'lodash'
export default {
  props: {
    searchData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    this.buttonIndex = -1
    this.inDialog = true
    return {
      showDialog: false,
      meta: {},
      params: {},
      subData: {},
      checkedValue: {},
      checkedValues: [],
    }
  },
  methods: {
    handleButton(index, row, button, searchData) {
      if(button.disabled){
        return
      }
      const script = button.event.script||''
      switch (button.event.type) {
        case 'router':
          this.updateMethod(button.event, row, searchData)
          break
        case 'cancel':
          this.goBack()
          this.delMyself({ path: this.$route.path })
          break
        case 'custom':
          if (~script.indexOf('function')) {
            const Fn = Function
            new Fn('return ' + script)()()
          } else {
            window[script] && window[script]()
          }
          break
        case 'dialog':
          this.showReport(button.event, row, index)
          break
        case 'ajax':
          this.ajaxMethod(button.event, row, index)
          break
        case 'dialog-report':
          this.showReport(button.event, row, index)
          break
        case 'dialog-report-column':
          this.showReportColumn(button.event, row, index)
          break
        default:
          this.$emit('button-method', event)
          break
      }
    },
    // 里面单选 外面多选
    sureInHeader(rows) {
      const button = this.buttons[this.buttonIndex].event
      const sureMethod = button.sure
      let values = this.checkedValue
      if(_.isEmpty(values)) {
        this.$message.warning('请选择')
        return
      }
      const params = button.params
      let newObj = []
      if (params) {
        rows.forEach(row => {
          const temp = {}
          params.forEach(item => {
            temp[item] = row[item]
          })
          newObj.push(temp)
        })
      } else {
        newObj = rows
      }
      rows.forEach(row => {
        _.merge(row, values)
      })

      const newEvent = {
        url: sureMethod.path,
        params: rows,
        ajaxType: sureMethod.ajaxType,
        callBack: sureMethod.callBack
      }
      if (sureMethod.confirm) {
        const confirm = sureMethod.confirm
        this.$confirm(confirm.message, confirm.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.realSendAjax(newEvent, this.buttonIndex, rows)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        this.realSendAjax(newEvent, this.buttonIndex, rows)
      }
    },
    sureBaseForm(sureMethod,button){

      let customDialogBaseForm =  this.$refs['customDialogBaseForm']
      const newEvent = {
        type: 'submit',
        path: sureMethod.path,
        ajaxType: sureMethod.ajaxType,
        callback: sureMethod.callback
      }
      const params = button.params
      let newObj = {}
      if (params) {
        params.forEach(item => {
          newObj[item] = this.rowData[item]
        })
      } else {
        newObj = this.rowData
      }
      if (sureMethod.confirm) {
        const confirm = sureMethod.confirm
        this.$confirm(confirm.message, confirm.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          customDialogBaseForm.submitMethod(newEvent,newObj)

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        customDialogBaseForm.submitMethod(newEvent,newObj)
      }
    },
    sureInTable() {
      const buttonColumn = this.realTableColumns.filter((item) => {
        if(item.type && item.type === 'button') {
          return true
        } else {
          return false
        }
      })[0]
      const buttons = buttonColumn.buttons[this.buttonIndex]
      const button = buttons.event
      const sureMethod = button.sure
      if(this.isBaseForm){
        this.sureBaseForm(sureMethod,button)
        return
      }
      let values = this.checkedValues.length > 0 ? this.checkedValues : this.checkedValue
      if (_.isArray(values)) {
        if(values.length <= 0) {
          this.$message.warning('请选择')
          return
        }
      } else {
        if(_.isEmpty(values)) {
          this.$message.warning('请选择')
          return
        }
      }
      const params = button.params
      let newObj = {}
      if (params) {
        params.forEach(item => {
          newObj[item] = this.rowData[item]
        })
      } else {
        newObj = this.rowData
      }
      // newObj['gaoyang'] = '111'
      if (_.isArray(values)) {
        values.forEach(value => {
          _.merge(value, newObj)
        })
      } else {
        values = _.merge(values, newObj)
      }
      const newEvent = {
        url: sureMethod.path,
        params: values,
        ajaxType: sureMethod.ajaxType,
        callBack: sureMethod.callBack
      }
      if (sureMethod.confirm) {
        const confirm = sureMethod.confirm
        this.$confirm(confirm.message, confirm.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.realSendAjax(newEvent, this.buttonIndex, this.rowData)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        this.realSendAjax(newEvent, this.buttonIndex, this.rowData)
      }
    },
    sure(index, row) {
      const button = this.buttons[this.buttonIndex].event
      const sureMethod = button.sure
      let values = this.checkedValues.length > 0 ? this.checkedValues : this.checkedValue
      if (_.isArray(values)) {
        if(values.length <= 0) {
          this.$message.warning('请选择')
          return
        }
      } else {
        if(_.isEmpty(values)) {
          this.$message.warning('请选择')
          return
        }
      }
      const params = button.params
      let newObj = {}
      if (params) {
        params.forEach(item => {
          newObj[item] = row[item]
        })
      } else {
        newObj = row
      }
      // newObj['gaoyang'] = '111'
      if (_.isArray(values)) {
        values.forEach(value => {
          _.merge(value, newObj)
        })
      } else {
        values = _.merge(values, newObj)
      }
      const newEvent = {
        url: sureMethod.path,
        params: values,
        ajaxType: sureMethod.ajaxType
      }
      if (sureMethod.confirm) {
        const confirm = sureMethod.confirm
        this.$confirm(confirm.message, confirm.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.realSendAjax(newEvent, index, row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        this.realSendAjax(newEvent, index, row)
      }
    },
    getCheckedReport(val) {
      this.checkedValues = val
    },
    radioCheckedMethod(val) {
      this.checkedValue = val
    },
    reset() {
      this.rowData = null
      this.showDialog = false
      this.checkedValue = {}
      this.checkedValues = []
      this.buttonIndex = -1
    },
    updateMethod(event, row, searchData = {}) {
      let params = event.params || []
      let query = {}
      if (!_.isArray(params)) {
        params = params.split(',')
      }
      params.forEach((item) => {
        if (item === 'details' || item === 'edit') {
          query['fromType'] = item
        } else {
          query[item] = row[item]
        }
      })
      let search = {}
      params.forEach((item) => {
        if (item === 'details' || item === 'edit') {
          query['fromType'] = item
        } else {
          if (searchData[item]) {
            search[item] = searchData[item]
          }
        }
      })
      query = _.merge({}, event.static || {}, search, query)
      // query = _.merge({}, query, event.static || {}, searchData)/
      if (event.configKey) {
        event.path = '/config/' + encodeURIComponent(event.configKey)
      }
      if (event.tab) {
        event.path = '/tab/' + encodeURIComponent(event.tab)
      }
      if(query.method === 'update' && process.env.PROJECT === 'dealer_pc'){
          query._ = Date.now()
      }
      this.$router.push({
        path: event.path,
        query: query
      })
    },
    ajaxMethod(Nevent, row, index) {
      const callback = Nevent.callBack || { showMessage: true }
      if(callback.addDataBack) {
        if(this.subData[index]) {
          this.subData[index].open = !this.subData[index].open
          this.$emit('addDataBack', {
            type: callback.addDataBack,
            data: this.subData[index].data,
            index,
            open: this.subData[index].open
          })
          return
        }
      }
      const event = _.cloneDeep(Nevent)
      const that = this
      let params = event.params || []
      if (!_.isArray(params)) {
        params = params.split(',')
      }
      const query = {}
      let url = event.path
      params.forEach((item) => {
        query[item] = row[item]
        url = _.replace(url, '{' + item + '}', row[item])
      })
      event.params = query
      event.url = url
      if (event.confirm) {
        const confirm = event.confirm
        this.$confirm(confirm.message, confirm.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          that.realSendAjax(event, index, row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        that.realSendAjax(event, index, row)
      }
    },
    realSendAjax(query, index, row) {
      if(this.type === 'switch'){
        query.params['noLoading'] = true
      }
      const callback = query.callBack || { showMessage: true, refresh: true }
      ajaxSend(query).then(res => {
        if (res.code === 0) {
          if(callback.showMessage) {
            this.$message({
              type: 'success',
              message: '操作成功',
              showClose: true
            })
          }
          if(query.isDownload){
            this.realDownLoad(row)
          }
          if (callback.refresh && this.type !== 'switch') {
              this.$emit('refresh', index, query.requestType)
              this.$refs.customdialogReport && this.$refs.customdialogReport.resetCheckeds()
          }
          if (callback.autoClose) {
            this.showDialog = false
          }
          if(index) {
            this.subData[index] = {
              data: res.data,
              open: true
            }
          }
          if (callback.addDataBack) {
            this.$emit('addDataBack', {
              type: callback.addDataBack,
              data: res.data.data,
              index,
              open: true
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message,
            showClose: true
          })
          this.ajaxErrorCb(query,index,row)
        }
      }).catch((error) => {
        this.ajaxErrorCb(query,index,row)
        this.$message({
          type: 'error',
          message: error,
          showClose: true
        })
      })
    },
    // switch类型的接口异常需要恢复原来的状态
    ajaxErrorCb(query, index, row){
      console.log( row[this.name])
      if(this.type === 'switch'){
        row[this.name] = !row[this.name]
      }
    },
    getReportMeta(event, row) {
      const configKey = event.configKey
      const params = event.params
      const query = {}
      row && params && params.forEach((item) => {
        query[item] = row[item]
      })
      this.params = query
      if (configKey) {
        getConfig(configKey).then(res => {
          this.meta = res.data.meta
          this.$nextTick(()=>{
            if(this.meta.type === 'base-form'){
               console.log(this.$refs)
              this.meta.items.forEach((item,index)=>{
                if(row[item.name]){
                  item.value = row[item.name]
                }
              })
              this.$refs['customDialogBaseForm'].dealDetailData({data: query,code: 0})
            }
          })
        })
      } else {
        this.showDialog = false
        this.$nextTick(() => {
          this.$message.error('请先配置configKey')
        })
      }
    },
    showReport(event, row, index) {
      this.buttonIndex = index
      this.showDialog = true
      this.rowData = row
      this.getReportMeta(event, row)
    },
    showReportColumn(event, row, index) {
      this.buttonIndex = index
      this.showDialog = true
      this.rowData = row
      this.$emit('showReport', {
        event,
        row,
        index
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/columnsMixin.js